import React, { useState, useEffect, useCallback } from 'react';
import {
  Button,
  Chip,
  Container,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  Checkbox,
  Box
} from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { DuePaymentRegisterReportPdf } from '../../../../Print/options/Hospital/HMS';

export const DuePaymentRegisterReport = () => {
  const { pathname } = useLocation();
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [openPrint, setOpenPrint] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const schema = Yup.object().shape({
    from_date: Yup.string().required(' '),
    to_date: Yup.string().required(' '),
    sponsor: Yup.array().min(1, ' ')
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      from_date: '',
      to_date: '',
      sponsor: []
    },
    mode: 'all'
  });

  const { watch, control, setValue } = methods;

  const getSponsorDropdown = useCallback(async () => {
    try {
      const data = await dropdownFetch('sponsor');
      setSponsorDropdown([{ _id: 'selectAll', name: 'Select All' }, ...data]);
    } catch (error) {
      console.error('Error fetching sponsor data:', error);
    }
  }, []);

  useEffect(() => {
    getSponsorDropdown();
  }, [getSponsorDropdown]);

  const handleSelectAll = (event) => {
    const isSelected = event.target.checked;
    const allSponsorNames = sponsorDropdown.filter((option) => option._id !== 'selectAll').map((option) => option.name);
    methods.setValue('sponsor', isSelected ? allSponsorNames : [], { shouldValidate: true, shouldDirty: true });
    setDropdownOpen(true); // Ensure dropdown remains open after selection
  };

  const MultiSelectDropdown = () => {
    const selectedValues = watch('sponsor');

    return (
      <FormControl fullWidth sx={{ mt: '1%', ml: '21%' }}>
        <InputLabel style={{ fontSize: '10px', color: 'black', fontWeight: 'bolder' }}>Sponsor Name</InputLabel>
        <Controller
          name="sponsor"
          control={control}
          render={({ field }) => (
            <Select
              multiple
              value={field.value}
              open={dropdownOpen}
              onOpen={() => setDropdownOpen(true)}
              onClose={() => setDropdownOpen(false)}
              onChange={(event) => {
                field.onChange(event.target.value);
                setDropdownOpen(true);
              }}
              style={{ width: '79%', padding: 0 }}
              renderValue={(selected) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', padding: 0 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </div>
              )}
              sx={{
                padding: '8px',
                width: '200px'
              }}
            >
              <MenuItem key="selectAll">
                <Checkbox
                  checked={selectedValues.length === sponsorDropdown.length - 1}
                  indeterminate={selectedValues.length > 0 && selectedValues.length < sponsorDropdown.length - 1}
                  onChange={handleSelectAll}
                />
                <Typography>Select All</Typography>
              </MenuItem>
              {sponsorDropdown.map(
                (option) =>
                  option._id !== 'selectAll' && (
                    <MenuItem key={option._id} value={option.name}>
                      <Checkbox checked={selectedValues.indexOf(option.name) > -1} />
                      <Typography>{option.name}</Typography>
                    </MenuItem>
                  )
              )}
            </Select>
          )}
        />
      </FormControl>
    );
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Due Payment Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('sponsor').length}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        sponsor: watch('sponsor'),
                        from_date: watch('from_date'),
                        to_date: watch('to_date')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%', boxShadow: '0px 2px 10px #0099ff' }}>
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
                <MultiSelectDropdown />
              </Grid>
            </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <DuePaymentRegisterReportPdf />
      </Dialog>
    </>
  );
};
